import { buildSectionUpdate } from '@griply/services';
import { useUpdateGoal } from 'features/goals';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';
import { v4 as uuidv4 } from 'uuid';

import { useGoalById } from './use-goal-by-id';

export const useCreateGoalSection = (goalId?: ID) => {
  const goal = useGoalById(goalId);
  const { submit: updateGoal } = useUpdateGoal();

  return useCallback(() => {
    if (!goal?.id) {
      return;
    }

    updateGoal(
      buildSectionUpdate(goal, {
        id: uuidv4(),
        name: '',
        createdAt: new Date(),
      }),
    );
  }, [goal, updateGoal]);
};
